import { useEffect, useState } from "react";
import Facturacion from "../../page/facturacion/Facturacion";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import { add, format } from "date-fns";

const FacturacionController = () => {
  const [resumen, setResumen] = useState(null);
  const [analisis, setAnalisis] = useState(null);
  const [detalles, setDetalles] = useState(null);

  
  const [params, setParams] = useState({
    fecha_desde: format(add(new Date(), { months: -12 }), "yyyy/MM/dd").toString(),
    fecha_hasta: format(new Date(), "yyyy/MM/dd").toString(),
    per_page: 10000
  });

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!resumen) {
      fetch(setResumen, {}, "/facturacion/resumen");
    }
  }, []);

  useEffect(() => {
    if (!analisis) {
      fetch(setAnalisis, {}, "/facturacion/analisis");
    }
  }, []);

  useEffect(() => {
    if (!detalles) {
      let filter = {
        ...params
      };
      fetch(setDetalles, filter, "/facturacion");
    }
  }, []);
  return (
    <Facturacion
      resumen={
        resumen ?? {
          "ingresos-mensuales": [],
          "top-salas": [],
          "total-descuento": 0,
          "total-entradas": 0,
          "total-ventas": 0,
          "ventas-entradas-mes": [],
        }
      }
      analisis={
        analisis ?? {
          "redimiento-sala": [],
          "total-categoria": [],
          "total-semanal": [],
        }
      }
      detalles={detalles ?? { data: [], links: [] }}
      params={params}
      setParams={setParams}
      fetch={fetch}
      setDetalles={setDetalles}
    />
  );
};

export default FacturacionController;
